const pcnoverview = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'PCN Overview',
            },
            {
                "type": "tabs",
                "size": "8",
                "style": "",
                "class": "pr-4",
                "children": [
                    {
                        "title": "PCN Overview",
                        "service": "category",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "updateSuccessTitle": 'Category Updated!',
                            "updateSuccessMessage": 'Category Updated Successfully!',
                            "updateErrorTitle": 'Category Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                        },
                        "children": [
                            {
                                "type": "onlineServicesTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0",
                                "list": {
                                    "type": "list",
                                    "size": "4",
                                    "style": "",
                                    "class": "p-2",
                                    "empty": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "min-height: calc(100vh - 144px)",
                                    "class": "pl-3 pt-3",
                                    "form": {
                                        "page_title": {
                                            "type": 'text',
                                            "label": 'Title',
                                            "placeholder": 'Enter Title',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "hr1": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "logo": {
                                            "type": 'imgSelect',
                                            "label": 'Logo',
                                            "placeholder": 'Select Logo',
                                            "load_url": '',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "6",
                                            "style": ""
                                        },
                                        "hr2": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "text": {
                                            "type": 'ckeditor',
                                            "label": 'Description',
                                            "placeholder": 'Enter Description',
                                            "required": true,
                                            "info": false,
                                            "character_count": 1000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "hr3": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "member_practices": {
                                            "type": 'toggle',
                                            "label": 'Member Practices',
                                            "placeholder": 'Select Featured',
                                            "required": false,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "hr4": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "governance_team": {
                                            "type": 'toggle',
                                            "label": 'Governance Team',
                                            "placeholder": 'Select Featured',
                                            "required": false,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "governance_team_title": {
                                            "type": 'text',
                                            "label": 'Governance Team Title',
                                            "placeholder": 'Enter Title',
                                            "displayOn": 'governance_team',
                                            "displayOnValue": 'true',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "governance_team_description": {
                                            "type": 'ckeditor',
                                            "label": 'Governance Team Description',
                                            "placeholder": 'Enter Description',
                                            "displayOn": 'governance_team',
                                            "displayOnValue": 'true',
                                            "required": false,
                                            "info": false,
                                            "character_count": 2000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "image": {
                                            "type": 'imgSelectHide',
                                            "label": 'Image',
                                            "placeholder": 'Select Image',
                                            "displayOn": 'governance_team',
                                            "displayOnValue": 'true',
                                            "load_url": '',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "6",
                                            "style": ""
                                        },
                                        "footnote": {
                                            "type": 'text',
                                            "label": 'Footnote',
                                            "placeholder": 'Enter Footnote',
                                            "displayOn": 'governance_team',
                                            "displayOnValue": 'true',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "hr5": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "what_is_pcn": {
                                            "type": 'toggle',
                                            "label": 'What is a PCN?',
                                            "placeholder": 'Select Featured',
                                            "required": false,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "hr6": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "what_is_pcn_check": {
                                            "type": 'checkbox',
                                            "label": 'Related Information',
                                            "placeholder": 'What is a PCN?',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "pcn_service_check": {
                                            "type": 'checkbox',
                                            "label": '2',
                                            "hideLabel": true,
                                            "placeholder": 'PCN Services',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "pcn_team_check": {
                                            "type": 'checkbox',
                                            "label": '1',
                                            "hideLabel": true,
                                            "placeholder": 'PCN Team',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "extended_hours": {
                                            "type": 'checkbox',
                                            "label": '3',
                                            "hideLabel": true,
                                            "placeholder": 'Extended Hours',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            },                            
                        ]
                    },
                ]
            },

        ]
    }
]

export { pcnoverview };